export var Placement;
(function (Placement) {
    Placement["Top"] = "top";
    Placement["TopStart"] = "top-start";
    Placement["TopEnd"] = "top-end";
    Placement["Bottom"] = "bottom";
    Placement["BottomStart"] = "bottom-start";
    Placement["BottomEnd"] = "bottom-end";
    Placement["Left"] = "left";
    Placement["LeftStart"] = "left-start";
    Placement["LeftEnd"] = "left-end";
    Placement["Right"] = "right";
    Placement["RightStart"] = "right-start";
    Placement["RightEnd"] = "right-end";
})(Placement || (Placement = {}));
